import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
        homepage: {
                backgroundImage: "url(/resources/Background.png)",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                height: "100%"
            },
        homepageLogo: {
                padding: "2em"
            },
        homepageTitle: {
                padding: "1.5em",
                color: "#2296aa"
            }
    }));